module.exports = __webpack_public_path__ + "static/ashurst--dark-e9f95e2cc12e1b2a7537c73b1f80e84a.png";